import initAegis from './tx-cloud'
import initSkywalking from './skywalking'

export default function setupMonitor() {
  initAegis()
  initSkywalking()
}
